import { MOCK_DASHBOARD, MOCK_KNOWLEDGE_BASES } from '../../mock/fixtures';
import type { DashboardCounters, KnowledgeBase } from '../../mock/fixtures';
import { mockRequest } from '../../mock/transport';

/** Số đếm rỗng, để diễn trạng thái `?mock=empty` của dashboard. */
const EMPTY_COUNTERS: DashboardCounters = {
  tongChungTu: 0,
  soMauOcr: 0,
  boTriThuc: 0,
  tepTaiLieu: 0,
  chatbotHoatDong: 0,
  chatbotDaCauHinh: 0,
  nguoiDungHoatDong: 0,
  tongTaiKhoan: 0,
  chungTuNhap: 0,
  chungTuDaXacNhan: 0,
  chungTuDaChuyenKho: 0,
  soVaiTro: 0,
  soPhongBan: 0,
};

export const dashboardRepository = {
  counters: (): Promise<DashboardCounters> => mockRequest(MOCK_DASHBOARD, EMPTY_COUNTERS),
  knowledgeBases: (): Promise<KnowledgeBase[]> => mockRequest(MOCK_KNOWLEDGE_BASES, []),
};
